import { Button, type ButtonProps, type ComponentWithAs, type IconProps } from "@chakra-ui/react"

type Props = {
  iconSize?: number
  iconColor?: string
  icon?: ComponentWithAs<"svg", IconProps>
} & ButtonProps

export const ButtonWithIcon: React.FC<Props> = ({
  icon: Icon,
  iconSize,
  iconColor,
  children,
  ...buttonProps
}) => {
  return (
    <Button
      variant={buttonProps.variant ?? "link"}
      display={buttonProps.display ?? "flex"}
      gap="1"
      alignItems="center"
      textStyle={buttonProps.textStyle ?? "link"}
      fontWeight={600}
      {...buttonProps}
    >
      {Icon && <Icon boxSize={iconSize ?? 4} color={iconColor} />}
      {children}
    </Button>
  )
}
